if (!customElements.get('card-slider')) {
  class CardSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      window.addEventListener('shopify:section:load', () => {
        this.initSlider(swiperOptions);
      });

      this.initSlider(swiperOptions);

      if (this.classList.contains('js-testimonials')) {
        const initOrUpdateSlider = () => {
          const isMobile = window.innerWidth < mobileWidth;
          const isSlideEffect = this.slider && this.slider.params.effect === 'slide';

          if (isMobile && !isSlideEffect || !isMobile && isSlideEffect) {
            this.reInitSlider(swiperOptions);
          }
        };

        initOrUpdateSlider();

        window.addEventListener('resize', initOrUpdateSlider);
      }

      // if window is resized, re-init slider
      window.addEventListener('resize', () => {
        if (swiperOptions.disabledOnMobile && window.innerWidth < mobileWidth) {
          if (this.slider) {
            this.slider.destroy();
          }
        } else if (!this.slider) {
          this.initSlider(swiperOptions);
        }
      });
    }

    reInitSlider(swiperOptions) {
      this.slider.destroy();
      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {

      // swiperOptions.disabledOnMobile = true;
      if (swiperOptions.disabledOnMobile && window.innerWidth < mobileWidth) {
        return;
      }

      let sliderOptions = {
        slidesPerView: 1.3,
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        resistanceRatio: 0.72,
        navigation: swiperOptions.navigation || { nextEl: '.swiper-button--next', prevEl: '.swiper-button--prev' },
        breakpoints: {
          480: {
            slidesPerView: 'auto',
            spaceBetween: swiperOptions.spaceBetweenMobile || 2,
          },
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
          }
        }
      };

      const isArticlesSlider = this.classList.contains('js-articles');
      const isCollectionSlider = this.classList.contains('js-collections');
      const isFeaturedProductsSlider = this.classList.contains('js-featured-products');

      if (isArticlesSlider || isCollectionSlider || isFeaturedProductsSlider) {
        sliderOptions.breakpoints[575] = {
          slidesPerView: 2,
        };
      } else if (this.classList.contains('horizontal-w-media')) {
        sliderOptions = {
            rewind: true,
            followFinger: false,
            slidesPerView: 1.15,
            spaceBetween: 16,
            pagination: {
              el: '.swiper-pagination',
              type: 'progressbar',
            },
            navigation: {
                nextEl: '.swiper-button--next',
                prevEl: '.swiper-button--prev',
            },
            loop: swiperOptions.loop || false,
            autoplay: swiperOptions.autoplay || false,
            breakpoints: {
              990: {
                  slidesPerView: 1
              },
              768: {
                  slidesPerView: 2.2,
              }
            },
            on: {
              init: this.handleSlideChange.bind(this),
              slideChange: this.handleSlideChange.bind(this),
            }
        };
      } else if (this.classList.contains('vertical-w-media')) {
          sliderOptions = {
              rewind: true,
              followFinger: false,
              slidesPerView: 1.15,
              spaceBetween: 16,
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet: function (i, className) {
                  return `
                    <button class="${className}">
                      <span>${i + 1}</span>
                    </button>
                  `;
                }
              },
              navigation: {
                nextEl: ".swiper-button--next"
              },
              loop: swiperOptions.loop || false,
              autoplay: swiperOptions.autoplay || false,
              breakpoints: {
                990: {
                  slidesPerView: 1,
                  grid: {
                    rows: 3
                  }
                },
                768: {
                  slidesPerView: 2.2,
                  pagination: {
                    el: ".swiper-pagination",
                    type: "progressbar"
                  }
                },
                360: {
                  pagination: {
                    el: ".swiper-pagination",
                    type: "progressbar"
                  }
                }
              },
              on: {
                init: this.handleSlideChange.bind(this),
                slideChange: this.handleSlideChange.bind(this),
              }
          };
      } else if (this.classList.contains('carousel-none-media')) {
          sliderOptions = {
              rewind: true,
              followFinger: false,
              direction: 'horizontal',
              slidesPerView: 1.15,
              spaceBetween: 16,
              pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
              },
              loop: swiperOptions.loop || false,
              autoplay: swiperOptions.autoplay || false,
              breakpoints: {
                990: {
                    slidesPerView: 3.2,
                },
                768: {
                    slidesPerView: 2.2,
                }
              },
              on: {
                init: this.handleSlideChange.bind(this),
                slideChange: this.handleSlideChange.bind(this),
              }
          };
      } else {
        sliderOptions = {
          effect: 'fade',
          slidesPerView: 1,
          rewind: true,
          followFinger: false,
          navigation: {
            nextEl: '.swiper-button--next',
            prevEl: '.swiper-button--prev',
          },
        };
      }

      this.slider = new Swiper(this, sliderOptions);
    }

    handleSlideChange(swiper) {
      const progressBarContainer = this.querySelector('.swiper-pagination__progress-bar');
      if(progressBarContainer) {
        const progressBar = this.querySelectorAll('.swiper-pagination__progress-bar .swiper-pagination-progressbar-fill');
        progressBar.forEach((progress) => {
          progress.style.animation = 'none';
          progress.offsetHeight;
          progress.style.animation = 'progressAnimation var(--progress-bar-time)';
        });
      }
    }
  }

  customElements.define('card-slider', CardSlider);
}
